export default __webpack_public_path__ + "static/media/hgv_icon.d74ff96a.svg";